module.exports = __webpack_public_path__ + "img/number-black-1.a44ea340.png";